import { ICartItem } from '@/types/cart';
import { ISearchObject } from '@/types/search';
import { getCartItem } from './cart.service';

/**
 * Формирует массив позиций заказа для отправки на сервер.
 * @param object Аптека с препаратами.
 * @param cart Корзина пользователя.
 */
export function buildOrderItems(object: ISearchObject, cart: ICartItem[]) {
    return object.preps.map(item => ({
        prep_id: item.id,
        name: item.name,
        proizv_name: item.proizv_name,
        quantity: getCartItem(item.group_id, cart).quantity || 0,
        min_price: item.price,
        price_default: item.price_default
    }));
}